import "$styles/index.css"

// Spine menu + reading progress (from reference_html/js/site.js).
const ready = (fn) => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn, { once: true })
  } else {
    fn()
  }
}

ready(() => {
  const spine = document.querySelector("[data-fd-spine]")
  const menu = document.querySelector("[data-fd-menu]")

  if (spine && menu) {
    const toggle = () => {
      const open = menu.getAttribute("data-open") === "true"
      menu.setAttribute("data-open", open ? "false" : "true")
      spine.setAttribute("aria-expanded", open ? "false" : "true")
    }

    spine.addEventListener("click", toggle)
    menu.addEventListener("click", (event) => {
      if (event.target.closest("a")) return
      toggle()
    })
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && menu.getAttribute("data-open") === "true") {
        toggle()
      }
    })
  }

  const fill = document.querySelector("[data-fd-progress]")
  if (fill) {
    const update = () => {
      const d = document.documentElement
      const max = d.scrollHeight - d.clientHeight
      fill.style.width = `${max > 0 ? Math.min(100, (d.scrollTop / max) * 100) : 0}%`
    }
    window.addEventListener("scroll", update, { passive: true })
    window.addEventListener("resize", update)
    update()
  }
})
